"use client"

import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { useResponsive } from "@src/hooks"
import { useLayoutEffect, useState } from "react"
import tocbot from 'tocbot'

import 'tocbot/dist/tocbot.css'


const TOCSticky = () => {
  const [showSidebar, setShowSidebar] = useState(false)

  const { isMobile } = useResponsive()


  useLayoutEffect(() => {
    setTimeout(() => {
      tocbot.init({
        tocSelector: '.toc-sticky',
        contentSelector: '.js-toc-content',
        headingSelector: 'h1, h2, h3',
        activeLinkClass: 'is-active-link',
        positionFixedClass: 'is-position-fixed',
        listClass: 'toc-list',
        collapseDepth: 3,
        hasInnerContainers: true,
        headingsOffset: isMobile ? 100 : 200,
        scrollSmoothOffset: isMobile ? -80 : -150,
      })

      tocbot.refresh();
    }, 100)

    return () => {
      tocbot.destroy()
    }
  }, [])

  const handleShowSidebar = () => {
    setShowSidebar(prev => !prev)
  }

  return (
    <Box
      className="article-sidebar"
      sx={{
        borderRadius: "8px",
        position: "fixed",
        display: "flex",
        right: {
          xs: showSidebar ? 0 : "-300px",
          sm: showSidebar ? 0 : "-350px",
          md: showSidebar ? 0 : "-440px",
        },
        transition: "right 0.3s",
        zIndex: 1000,
      }}
    >
      <Box
        role="button"
        sx={{
          cursor: "pointer",
          width: "40px",
          height: "40px",
          color: "white",
          backgroundColor: "#333",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={handleShowSidebar}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="lucide lucide-table-of-contents"><path d="M16 12H3" /><path d="M16 18H3" /><path d="M16 6H3" /><path d="M21 12h.01" /><path d="M21 18h.01" /><path d="M21 6h.01" /></svg>
      </Box>
      <Box
        sx={{
          padding: "16px",
          backgroundColor: "#F9F9F9",
          width: {
            xs: 300,
            sm: 350,
            md: 440,
          },
          overflow: "hidden",
          "& ol.toc-list": {
            overflow: "hidden",
            position: "inherit"
          }
        }}>
        <Typography sx={{
          fontSize: "18px",
          fontWeight: 600,
          lineHeight: "32px",
          marginBottom: "12px"
        }}>
          Nội dung
        </Typography>
        <nav className="toc-sticky js-toc" style={{
          position: "relative"
        }}>
        </nav>
      </Box>
    </Box>
  )
}
export default TOCSticky
